import { IMetadataAuthoringRule, MetadataAuthoringRule } from '@adaptiva/metadata/common';
import { IParentMetadataAuthoringRule } from '../interfaces';

export class AndMetadataAuthoringRule implements IParentMetadataAuthoringRule {

	public type: int;

	public children: IMetadataAuthoringRule[];

	constructor(_children?: IMetadataAuthoringRule[]) {
		this.type = MetadataAuthoringRule.AND;
		if (_children) {
			this.children = _children;
		}
	}
}
